import { FeatureFlagEnum } from '@shared/enums/feature-flag.enum';
import { EnvironmentModel } from '@shared/models/environment.model';

export const environment: EnvironmentModel = {
  production: false,
  urls: { apiUrl: 'https://api.dashly-stage.com' },
  sentryDSN: 'https://70dd0b21d048139bc768b13b07c9ef26@o74825.ingest.us.sentry.io/4509779295076352',
  googleCloudPlatformApiKey: 'AIzaSyBLnif_UIJLpm7smz9RWfQjIWYkrB6QqWs',
  maintenanceUrl: 'https://storage.googleapis.com/dashlystage-ui-apps-config/config.json',
  featureConfig: {
    [FeatureFlagEnum.AddSmartSearchForm]: true,
    [FeatureFlagEnum.MobileAppRedirect]: false,
  },
  companyAndNetworkIds: {
    dashlyCompanyId: '5',
    mabNetworkId: '1',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyCUeSC8_VGVK47D7Ud40eHbP-0Ef2pGoFI',
    authDomain: 'dashlystage.firebaseapp.com',
    projectId: 'dashlystage',
    storageBucket: 'dashlystage.firebasestorage.app',
    messagingSenderId: '969402024566',
    appId: '1:969402024566:web:a0eacceee0cf7595759557',
  },
};
